import { jsx as e, jsxs as l, Fragment as f } from "react/jsx-runtime";
import p from "react";
import u from "../../../Icons/ArrowRight.js";
import I from "../../../Icons/CircleArrowRight.js";
import { MenuColumnTheme as v } from "../../interfaces.js";
import { getNavId as N } from "../helpers.js";
import { NavItem as g, NavLink as A, LinkText as R, IconWrapper as x, IconWrapperOutline as $ } from "./styled.js";
const C = ({
  isActive: r,
  item: t,
  onSelect: i,
  $colorScheme: o,
  colNum: m,
  rowNum: n
  // onItemClick = () => {}
}) => {
  const { text: c, href: a, subItems: s = [] } = t, d = N(m, n), h = s.length > 0;
  return /* @__PURE__ */ e(
    g,
    {
      $isActive: r,
      $colorScheme: o ?? v.DARK_GREY,
      children: /* @__PURE__ */ l(A, { id: d, href: a, onFocus: i, onMouseEnter: i, children: [
        /* @__PURE__ */ e(R, { children: c }),
        h && /* @__PURE__ */ e(f, { children: r ? /* @__PURE__ */ e(x, { children: /* @__PURE__ */ e(I, {}) }) : /* @__PURE__ */ e($, { children: /* @__PURE__ */ e(u, {}) }) })
      ] })
    }
  );
}, M = p.memo(
  C,
  (r, t) => r.item.id === t.item.id && r.isActive === t.isActive
);
export {
  M as default
};
